module.exports = __webpack_public_path__ + "static/media/icon_4pin_19px.7d7833a2.svg";